import { faker } from '@faker-js/faker';
import type { DealroomNotificationEvent, Notification } from '../notification.types';
import { NotificationType } from '../notification.types';
import { DealroomEventType } from '../../../timeline/types/log.types';

export default class NotificationMock {
  private static mockableEvents = [
    DealroomEventType.FileDeleted,
    DealroomEventType.FileUploaded,
    DealroomEventType.Deleted,
    DealroomEventType.PostCreated,
    DealroomEventType.Visited,
  ];

  static one(properties?: Partial<Notification>): Notification {
    return {
      id: faker.string.uuid(),
      entityId: faker.string.uuid(),
      createdAt: faker.date.past().getTime(),
      viewedAt: faker.date.past().getTime(),
      summaryId: faker.string.uuid(),
      data: {
        type: NotificationType.Dealroom,
        dealroomId: faker.string.uuid(),
        participantId: faker.string.uuid(),
        userId: faker.string.uuid(),
        event: {
          type: this.mockableEvents[
            faker.number.int({ min: 0, max: this.mockableEvents.length - 1 })
          ],
        } as DealroomNotificationEvent,
      },
      ...properties,
    };
  }

  static many(count = 2): Notification[] {
    const notifications: Notification[] = [];
    for (let i = 0; i < count; i++) {
      notifications.push(this.one());
    }
    return notifications;
  }
}
